import React, { useContext, useRef, useState, useEffect, Fragment } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../../Context/UserContext.js';
import { PatientContext } from '../../Context/PatientContext.js';
import style from "./paymentMethod.module.css";
import instapay from "../../Assets/images/instapay.webp";

export default function PaymentMethod({ userData }) {
   const closeBtnRef = useRef();
   const [paymentMethod, setPaymentMethod] = useState("");
   const [methods, setMethods] = useState([]);
   const [walletResponse, setWalletResponse] = useState(null);
   const { setLoading, patient } = useContext(PatientContext);
   const { userToken, user } = useContext(UserContext);
   const navigate = useNavigate();
   const location = useLocation();
   const profile = new URLSearchParams(location.search).get("profile");

   const [loading, setLocalLoading] = useState(false);

   useEffect(() => {
      if (userData) {
         localStorage.setItem("userData", JSON.stringify(userData));
      }
   }, [userData]);

   const savedUserData = JSON.parse(localStorage.getItem("userData"));
   const finalUserData = userData || savedUserData;



   const header = {
      token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   };

   useEffect(() => {
      axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/order/paymentMethod`, { headers: header })
         .then((res) => {
            let apiMethods = res.data?.payment_method?.data || [];

            //  Disable Aman & Bebasata & apple pay
            apiMethods = apiMethods.map((m) => {
               if (
                  m.name_en?.toLowerCase().includes("aman") ||
                  m.name_ar?.toLowerCase().includes("بساطة") ||
                  m.name_en?.toLowerCase().includes("applepay")
               ) {
                  return { ...m, disabled: true };
               }
               return { ...m, disabled: false };
            });

            const staticInstapay = {
               paymentId: "instapay",
               name_en: "Instapay",
               name_ar: "إنستا باى",
               redirect: "true",
               logo: instapay,
               disabled: false,
            };

            setMethods([...apiMethods, staticInstapay]);
         })
         .catch((err) => {
            toast.error(err.response?.data?.message || "Failed to fetch payment methods");
         });
   }, []);

   const handleMethod = (id) => {
      setPaymentMethod(id);
      setWalletResponse(null);
   };

   async function submitOrder() {
      closeBtnRef.current.click();
      setLocalLoading(true);
      setLoading(true);

      if (paymentMethod === "instapay") {
         navigate("/Instapay",
            {
               state: {
                  userData,
                  profile: profile || false,
               },
            }
         );
         setLocalLoading(false);
         setLoading(false);
         return;
      }

      if (paymentMethod === 4) {
         navigate("/wallet-payment", {
            state: {
               userData,
               paymentMethod: 4,
               profile: profile || false,
            },
         });
         setLocalLoading(false);
         setLoading(false);
         return;
      }

      const age = new Date().getFullYear() - new Date(finalUserData?.birthDay).getFullYear();

      const payload = {
         patient_Name: finalUserData?.patient_Name,
         patient_Phone: finalUserData?.patient_Phone,
         birthDay: finalUserData?.birthDay,
         gender: finalUserData?.gender,
         age: age,
         email: user?.email || "test@rmail.com",
         payment_method_id: paymentMethod,
      };


      try {
         const { data } = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/api/v1/order/create-session?profile=${profile || false}`,
            payload,
            { headers: header }
         );

         if (data?.success) {
            if (paymentMethod === 3) {
               navigate("/fawry-payment", {
                  state: { fawryResponse: data },
               });
            } else {
               window.location.href = data?.invoice?.payment_data?.redirectTo;
            }
         } else {
            toast.error("فشل في إنشاء الطلب");
         }
      } catch (error) {
         toast.error(error.response?.data?.message || "خطأ أثناء الدفع");
      } finally {
         setLocalLoading(false);
         setLoading(false);
      }
   }

   return (
      <Fragment>
         <div className="PaymentMethod-container">
            <div className="modal fade" id="PaymentMethod" tabIndex="-1" aria-labelledby="PaymentMethodLabel" aria-hidden="true">
               <div className="modal-dialog ">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h5 className="modal-title" id="PaymentMethodLabel">أختيار طريقة الدفع</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeBtnRef}></button>
                     </div>
                     <div className="modal-body">
                        {methods.map((ele) => (
                           <label
                              key={ele.paymentId}
                              htmlFor={ele.paymentId}
                              className={`row rounded-1 mx-4 bg-body-secondary my-1 ${style.card} ${ele.disabled ? "opacity-50" : ""}`}
                              style={{ cursor: ele.disabled ? "not-allowed" : "pointer" }}
                           >
                              <div className="d-flex justify-content-between align-items-center p-1 px-3 w-100">
                                 <img
                                    src={ele.logo}
                                    alt={ele.name_ar}
                                    className={style.paymentImage}
                                 />
                                 <h3 className="m-0">
                                    {ele.name_ar}{" "}
                                    {ele.disabled && <small className="text-muted">(قريباً)</small>}
                                 </h3>
                                 <input
                                    type="radio"
                                    id={ele.paymentId}
                                    onChange={() => !ele.disabled && handleMethod(ele.paymentId)}
                                    name="method"
                                    className={style.radio}
                                    disabled={ele.disabled}
                                 />
                              </div>
                           </label>
                        ))}

                        {/* Show wallet response */}
                        {walletResponse && (
                           <div className="alert alert-success mt-3 text-center">
                              <p>رقم المرجع: <b>{walletResponse.meezaReference}</b></p>
                              <p>تم إرسال رسالة SMS من محفظتك لإتمام الدفع</p>
                           </div>
                        )}
                     </div>

                     {paymentMethod === "" ? null : (
                        <div className='text-center my-3'>
                           <button
                              className='btn bg-main w-50'
                              onClick={submitOrder}
                              disabled={loading}
                           >
                              {loading ? "جاري المعالجة..." : "أدفع الأن"}
                           </button>
                           {loading && (
                              <div className="mt-3 text-center">
                                 <div className="spinner-border text-success" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                 </div>
                                 <p className="mt-2">جاري إرسال طلب الدفع...</p>
                              </div>
                           )}
                        </div>
                     )}
                  </div>
               </div>
            </div>
         </div>
      </Fragment>
   );
}


// useEffect(() => { axios.get(${process.env.REACT_APP_BASE_URL}/api/v1/order/paymentMethod, { headers: header }) .then((res) => { const apiMethods = res.data?.payment_method?.data || []; const staticInstapay = { paymentId: "instapay", name_en: "Instapay", name_ar: "إنستا باى", redirect: "true", logo: instapay }; setMethods([...apiMethods, staticInstapay]); }) .catch((err) => { toast.error(err.response?.data?.message || "Failed to fetch payment methods"); }); }, []);
//  {methods.map((ele) => (
//                            <label
//                               key={ele.paymentId}
//                               htmlFor={ele.paymentId}
//                               className={`row rounded-1 mx-4 bg-body-secondary my-1 ${style.card}`}
//                               style={{ cursor: "pointer" }}
//                            >
//                               <div className="d-flex justify-content-between align-items-center p-1 px-3 w-100">
//                                  <img
//                                     src={ele.logo}
//                                     alt={ele.name_ar}
//                                     className={style.paymentImage}
//                                  />
//                                  <h3 className="m-0">{ele.name_ar}</h3>
//                                  <input
//                                     type="radio"
//                                     id={ele.paymentId}
//                                     onChange={() => handleMethod(ele.paymentId)}
//                                     name="method"
//                                     className={style.radio}
//                                  />
//                               </div>
//                            </label>
//                         ))}